module.exports = __webpack_public_path__ + "img/confirm-hen.1654b46a.png";